import {
  SYSTEM_SALARYRANGE_MODAL_CHANGE,
} from './constants';

export function salaryRangeModalChange(visible,type) {
  return {
    type: SYSTEM_SALARYRANGE_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_SALARYRANGE_MODAL_CHANGE:
      return {
        ...state,
        salaryRangeModalType:action.data.type,
        salaryRangeModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/salaryRangeModalChange.js